import { FC } from "react";
import { Button, Flex } from "@radix-ui/themes";
import { SubmissionsItemProps } from "./submissions.item";
import { useUpdateStatus } from "../hooks/useUpdateStatus";

const SubmissionsItemActions: FC<SubmissionsItemProps> = ({
  data,
}): JSX.Element => {
  const isApproved = data.status === "approved";
  const isRejected = data.status === "rejected";
  const isPending = data.status === "pending";

  const { updateStatus, loading, error } = useUpdateStatus(data.id);

  if (isPending) {
    return (
      <Flex gap="3">
        <Button
          onClick={() => {
            updateStatus(data, "approved");
          }}
        >
          Approve
        </Button>
        <Button
          variant="soft"
          onClick={() => {
            updateStatus(data, "rejected");
          }}
        >
          Reject
        </Button>
      </Flex>
    );
  }

  if (isApproved) {
    return (
      <Flex gap="3">
        <Button
          variant="soft"
          onClick={() => {
            updateStatus(data, "rejected");
          }}
        >
          Reject
        </Button>
      </Flex>
    );
  }

  if (isRejected) {
    return (
      <Flex gap="3">
        <Button
          onClick={() => {
            updateStatus(data, "approved");
          }}
        >
          Approve
        </Button>
      </Flex>
    );
  }

  return <>Something went wrong</>;
};

export default SubmissionsItemActions;
